module.exports = __webpack_public_path__ + "static/img/active6.ef30eb7f.png";